<template>
  <div class="lawyer-serve-me">
    <div class="darkgray-font font">近期为我服务的律师</div>
    <div class="f-wrap">
      <div v-for="(item, index) in data" :key="index" class="f-cloumn m-r-60" @click="toDetails">
        <img class="lawyerAvatarImage m-t-25 m-b-10" :src="item.avatar" />
        <div class="font-lg f-center">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>
 
<script>
import { ref } from 'vue'
import router from '@/router'
import jz1Image from '@/assets/jz/1.png'
import jz2Image from '@/assets/jz/2.png'
import jz3Image from '@/assets/jz/3.png'
import jz4Image from '@/assets/jz/4.png'
import jz5Image from '@/assets/jz/5.png'

export default {
  setup(props, { emit }) {
    const data = ref([
      {
        name: '云文虹',
        avatar: jz1Image,
      },
      {
        name: '戴宇航',
        avatar: jz2Image,
      },
      {
        name: '林权',
        avatar: jz3Image,
      },
    ])
    const toDetails = () => {
      router.push('/lawyer/details/2')
    }
    return { data, toDetails }
  },
}
</script>

<style lang="scss">
.lawyer-serve-me {
  padding: 40px;
  background-color: #f1f2f5;
  .lawyerAvatarImage {
    width: 92px;
    height: 92px;
    border-radius: 50%;
  }
}
</style>